import { factoryService, authorizationService } from "../../_services"
import {FACTORY_ACTION_TYPES, COMMON_ACTION_TYPES, APP_MESSAGES} from "../../_constants";
import {exceptionHandler, utilFunctions} from "../../_helpers";
import {CreateFactoryPayloadStructure} from "../../_models/app.models";

const getAllSbuList = (isAdmin: boolean, userEmail: string, onSuccess, onError) => {
    return action => {
        if (isAdmin) {
            action({type: FACTORY_ACTION_TYPES.GET_SBU_LIST + COMMON_ACTION_TYPES.REQUEST})
            factoryService.getFactoryList(userEmail)
                .then( res => {
                    action({type: FACTORY_ACTION_TYPES.GET_SBU_LIST + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                    onSuccess(res.data);
                })
                .catch( error => {
                    action({type: FACTORY_ACTION_TYPES.GET_SBU_LIST + COMMON_ACTION_TYPES.ERROR, data: error})
                    onError(exceptionHandler.catchError(error.response))
                })
        } else {
            action({type: FACTORY_ACTION_TYPES.GET_SBU_LIST + COMMON_ACTION_TYPES.REQUEST})
            const factories = authorizationService.getAuthorizedUserFactories();
            action({type: FACTORY_ACTION_TYPES.GET_SBU_LIST + COMMON_ACTION_TYPES.SUCCESS, data: factories})
        }

    }
}

const getAllPlantList = (isAdmin: boolean, onSuccess, onError) => {
    return action => {
        if (isAdmin) {
            action({type: FACTORY_ACTION_TYPES.GET_PLANT_LIST + COMMON_ACTION_TYPES.REQUEST})
            factoryService.getFactoryList(null)
                .then( res => {
                    let plants = [];
                    if(res.data) {
                        res.data.forEach( sbu => {
                            sbu.plants.forEach ( plant => plants.push(plant))
                        })
                    }
                    action({type: FACTORY_ACTION_TYPES.GET_PLANT_LIST + COMMON_ACTION_TYPES.SUCCESS, data: plants})
                    onSuccess(plants);
                })
                .catch( error => {
                    action({type: FACTORY_ACTION_TYPES.GET_PLANT_LIST + COMMON_ACTION_TYPES.ERROR, data: error})
                    onError(exceptionHandler.catchError(error.response))
                })
        } else {
            action({type: FACTORY_ACTION_TYPES.GET_PLANT_LIST + COMMON_ACTION_TYPES.REQUEST})
            const factories = authorizationService.getAuthorizedUserFactories();
            let plants = [];
            if(factories) {
                factories.forEach( sbu => {
                    sbu.plants.forEach ( plant => plants.push(plant))
                })
            }
            action({type: FACTORY_ACTION_TYPES.GET_PLANT_LIST + COMMON_ACTION_TYPES.SUCCESS, data: plants})
            onSuccess(plants);
        }

    }
}

const getModulesByFactory = (factoryId: number, onSuccess, onError) => {
    return action => {
        action({type: FACTORY_ACTION_TYPES.GET_MODULE_LIST + COMMON_ACTION_TYPES.REQUEST})
        factoryService.getModulesByFactory(factoryId)
            .then( res => {
                action({type: FACTORY_ACTION_TYPES.GET_MODULE_LIST + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                onSuccess(res.data);
            })
            .catch( error => {
                action({type: FACTORY_ACTION_TYPES.GET_MODULE_LIST + COMMON_ACTION_TYPES.ERROR, data: error})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getModulesByFactoryCode = (factoryCode: string, onSuccess, onError) => {
    return action => {
        action({type: FACTORY_ACTION_TYPES.GET_MODULE_BY_FACTORY_CODE + COMMON_ACTION_TYPES.REQUEST})
        factoryService.getModulesByFactoryCode(factoryCode)
            .then( res => {
                action({type: FACTORY_ACTION_TYPES.GET_MODULE_BY_FACTORY_CODE + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                onSuccess(res.data);
            })
            .catch( error => {
                action({type: FACTORY_ACTION_TYPES.GET_MODULE_BY_FACTORY_CODE + COMMON_ACTION_TYPES.ERROR, data: error})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getAllFactoryList = (isAdmin: boolean, onSuccess, onError) => {
    return action => {
        if (isAdmin) {
            action({type: FACTORY_ACTION_TYPES.GET_FACTORY_LIST + COMMON_ACTION_TYPES.REQUEST})
            factoryService.getFactoryList(null)
                .then( res => {
                    const formattedFactories = utilFunctions.formatUserFactories(res.data)
                    action({type: FACTORY_ACTION_TYPES.GET_FACTORY_LIST + COMMON_ACTION_TYPES.SUCCESS, data: formattedFactories})
                    onSuccess(formattedFactories);
                })
                .catch( error => {
                    action({type: FACTORY_ACTION_TYPES.GET_FACTORY_LIST + COMMON_ACTION_TYPES.ERROR, data: error})
                    onError(exceptionHandler.catchError(error.response))
                })
        } else {
            action({type: FACTORY_ACTION_TYPES.GET_FACTORY_LIST + COMMON_ACTION_TYPES.REQUEST})
            const factories = authorizationService.getAuthorizedUserFactories();
            const formattedFactories = utilFunctions.formatUserFactories(factories)
            action({type: FACTORY_ACTION_TYPES.GET_FACTORY_LIST + COMMON_ACTION_TYPES.SUCCESS, data: formattedFactories})
            onSuccess(formattedFactories);
        }

    }
}


const createFactory = (payload: CreateFactoryPayloadStructure, onSuccess, onError) => {
    return action => {
        action({type: FACTORY_ACTION_TYPES.CREATE_FACTORY + COMMON_ACTION_TYPES.REQUEST})
        factoryService.createFactory(payload)
            .then( (res) => {
                let responseMessage;
                if(res.status === 200) {
                    responseMessage = APP_MESSAGES.FACTORY_UPDATE_SUCCESS;
                }
                if(res.status === 201) {
                    responseMessage = APP_MESSAGES.FACTORY_CREATE_SUCCESS;
                }
                action({type: FACTORY_ACTION_TYPES.CREATE_FACTORY + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                onSuccess(res.data, responseMessage)
            })
            .catch( (error) => {
                action({type: FACTORY_ACTION_TYPES.CREATE_FACTORY + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

export const factoryActions = {
    getAllSbuList,
    getAllPlantList,
    getAllFactoryList,
    createFactory,
    getModulesByFactory,
    getModulesByFactoryCode
};
